import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useMcpSurfaceAccess } from '../lib/mcpAccess'

/**
 * Route guard for the two MCP surfaces — MCP Config (`/mcp`) and MCP
 * Analytics (`/mcp-analytics`) — which the specs require to be gated
 * identically (MS-700 AC-1).
 *
 * A sibling of the Global-Admin guard rather than a widening of it, so the
 * audit-log and global-settings gates are untouched.
 *
 * UX gate only, NOT the security boundary: it exists so a caller without access
 * is not dropped onto a page whose first fetch would 403. Real enforcement is
 * server-side — `require_global_permission(level="Admin")` on every endpoint
 * these pages call. See lib/mcpAccess.ts.
 */
export function RequireMcpAccess({ children }: { children: ReactNode }) {
  const { canSeeMcpSurfaces } = useMcpSurfaceAccess()
  return canSeeMcpSurfaces ? <>{children}</> : <Navigate to="/home" replace />
}
